import React, { useState } from "react"
import "./services.css"
import { servicesData } from "./servicesData"

const Services = () => {
  const [activeModal, setActiveModal] = useState(0);

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I Offer</span>

      <p className="services__targeting">
        Currently taking on Shopify app builds, SaaS backend projects, and API integration work.
      </p>

      <div className="services__container container grid">
        {servicesData.map((service) => (
          <div className="services__content" key={service.id}>
            <div>
              <i className={`${service.icon} services__icon`}></i>
              <h3 className="services__title">
                {service.titleLine1}
                <br />
                {service.titleLine2}
              </h3>
            </div>

            <span className="services__button" onClick={() => setActiveModal(service.id)}>
              View More
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div className={activeModal === service.id ? "services__modal active-modal" : "services__modal"}>
              <div className="services__modal-content">
                <i onClick={() => setActiveModal(0)} className="uil uil-times services__modal-close"></i>
                <h3 className="services__modal-title">{service.title}</h3>
                <p className="services__modal-description">{service.description}</p>
                <ul className="services__modal-services grid">
                  {service.bullets.map((bullet, index) => (
                    <li className="services__modal-service" key={index}>
                      <i className="uil uil-check-circle"></i>
                      <p className="services__modal-info">{bullet}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Services
